import { ConfigProvider } from 'antd';
import es from 'antd/lib/locale/es_ES';
import moment from 'moment';
import 'moment/locale/es-mx';
import 'dayjs/locale/es';
import './App.scss';
import RouterContent from 'containers/RouterContent/RouterContent';

moment.locale('es-mx');

function App() {
  return (
    <div className="App">
      <ConfigProvider locale={es}>
        <RouterContent />
      </ConfigProvider>
    </div>
  );
}

export default App;
